module.exports = __webpack_public_path__ + "static/img/video-platforms__block-5.18ed983d.jpg";